
import { interpolate, join, toText, printf, toConsole } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { fold as fold_1, copy, setItem, item, map as map_5 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { sortByDescending, map as map_7, toList, toArray } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { iterate, item as item_1, map as map_6, fold } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { getItemFromDict } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { empty, toList as toList_1, tryFind, ofSeq, FSharpMap__get_Count, add, FSharpMap__get_Item, ofArray } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { createAtom, comparePrimitives } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { Union, Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { union_type, class_type, int32_type, string_type, record_type, float64_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { max, min } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { dbg } from "../Shared/Log.js";
import { MapModule_KeysA } from "./EEExtensions.js";

export function checkPerformance(m, n, startTimer, stopTimer) {
    toConsole(printf("Checking performance with size = %d, iterations = %d"))(m)(n);
    const arrayBuffer = () => {
        const buff = map_5((i) => (((i + 1) % m) | 0), toArray(rangeDouble(0, 1, m - 1)), Int32Array);
        let index = 0;
        let el = 0;
        startTimer("Array");
        while (index < n) {
            index = ((index + 1) | 0);
            el = (item(el, buff) | 0);
        }
        stopTimer("Array");
    };
    const arrayBufferLookup = () => {
        const buff_1 = map_5((i_1) => (((i_1 + 1) % m) | 0), toArray(rangeDouble(0, 1, m - 1)), Int32Array);
        let index_1 = 0;
        let el_1 = 0;
        startTimer("ArrayBufferLookup");
        while (index_1 < ~~(n / 2)) {
            index_1 = ((index_1 + 1) | 0);
            for (let i_2 = 0; i_2 <= ~~((m - 1) / 2); i_2++) {
                el_1 = ((item(el_1, buff_1) + index_1) | 0);
            }
        }
        stopTimer("ArrayBufferLookup");
    };
    const mutableArrayBuffer = () => {
        const buff_2 = map_5((i_3) => (((i_3 + 1) % m) | 0), toArray(rangeDouble(0, 1, m - 1)), Int32Array);
        let index_2 = 0;
        let el_2 = 0;
        startTimer("Mutable Array");
        while (index_2 < n) {
            index_2 = ((index_2 + 1) | 0);
            el_2 = ((((el_2 + 1) < m) ? (el_2 + 1) : 0) | 0);
            setItem(buff_2, el_2, index_2 | 0);
        }
        stopTimer("Mutable Array");
    };
    const updateArrayBuffer = () => {
        const buff_3 = map_5((i_4) => (((i_4 + 1) % m) | 0), toArray(rangeDouble(0, 1, m - 1)), Int32Array);
        let index_3 = 0;
        let el_3 = 0;
        let arr = buff_3;
        startTimer("Copy-update Array");
        item(0, fold((buff_4, i_5) => {
            const r = copy(buff_4);
            setItem(r, i_5 % m, i_5 | 0);
            return r;
        }, buff_3, toList(rangeDouble(0, 1, n))));
        stopTimer("Copy-update Array");
    };
    const listBuffer = () => {
        const buff_5 = map_6((i_6) => (((i_6 + 1) % m) | 0), toList(rangeDouble(0, 1, m - 1)));
        let index_4 = 0;
        let el_4 = 0;
        startTimer("List");
        while (index_4 < n) {
            index_4 = ((index_4 + 1) | 0);
            el_4 = (item_1(el_4, buff_5) | 0);
        }
        stopTimer("List");
    };
    const dictBuffer = () => {
        const dict = new Map([]);
        const array_4 = toArray(rangeDouble(0, 1, m - 1));
        array_4.forEach((i_7) => {
            dict.set(i_7, (i_7 + 1) % m);
        });
        let index_5 = 0;
        let el_5 = 0;
        startTimer("Dict");
        while (index_5 < n) {
            index_5 = ((index_5 + 1) | 0);
            el_5 = (getItemFromDict(dict, el_5) | 0);
        }
        stopTimer("Dict");
    };
    const mapBuffer = () => {
        const buff_6 = ofArray(map_5((i_8) => [i_8, (i_8 + 1) % m], toArray(rangeDouble(0, 1, m - 1))), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        let index_6 = 0;
        let el_6 = 0;
        startTimer("Map");
        while (index_6 < n) {
            index_6 = ((index_6 + 1) | 0);
            el_6 = (FSharpMap__get_Item(buff_6, el_6) | 0);
        }
        stopTimer("Map");
    };
    const updateMapBuffer = () => {
        const buff_7 = ofArray(map_5((i_9) => [i_9, (i_9 + 1) % m], toArray(rangeDouble(0, 1, m - 1))), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        });
        startTimer("UpdateMap");
        const buf = fold_1((buff_8, i_10) => add(i_10 % m, i_10, buff_8), buff_7, toArray(rangeDouble(0, 1, n - 1)));
        stopTimer("UpdateMap");
        FSharpMap__get_Count(buf);
    };
    arrayBuffer();
    arrayBuffer();
    arrayBufferLookup();
    arrayBufferLookup();
    mutableArrayBuffer();
    mutableArrayBuffer();
    updateArrayBuffer();
    updateArrayBuffer();
    listBuffer();
    listBuffer();
    mapBuffer();
    mapBuffer();
    dictBuffer();
    dictBuffer();
    updateMapBuffer();
    updateMapBuffer();
    const dict_1 = new Map([]);
    const array_8 = toArray(rangeDouble(0, 1, m - 1));
    array_8.forEach((i_11) => {
        dict_1.set(i_11, (i_11 + 1) % m);
    });
    startTimer("UpdateDict");
    fold_1((dict_2, i_12) => (new Map(dict_2)), dict_1, toArray(rangeDouble(0, 1, n - 1)));
    stopTimer("UpdateDict");
}

export function timeNowInMicroS() {
    return (performance.now()) * 1000;
}

export function timeNowInMS() {
    return performance.now();
}

export class Stats extends Record {
    constructor(Min, Max, Av, Num) {
        super();
        this.Min = Min;
        this.Max = Max;
        this.Av = Av;
        this.Num = Num;
    }
}

export function Stats_$reflection() {
    return record_type("TimeHelpers.Stats", [], Stats, () => [["Min", float64_type], ["Max", float64_type], ["Av", float64_type], ["Num", float64_type]]);
}

/**
 * add time t to st
 */
export function addTimeToStats(t, st) {
    return new Stats(min(st.Min, t), max(st.Max, t), ((st.Av * st.Num) + t) / (st.Num + 1), st.Num + 1);
}

export let executionStats = createAtom(ofSeq([], {
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
}));

/**
 * Run (f arg) recording its time in executionStats under name.
 * NB - this will run f multiple times if needed to estimate average speed more accurately.
 * If an execution time of 5ms for this function is too long reduce timeLimit.
 * The multiple time execution will not work, and will give lower than real results, if
 * f is memoised. In that case set timeLimit to 0. for only one execution.
 */
export function recordExecutionTimeStats(name, f, arg) {
    let value_1, option_1;
    const t1 = timeNowInMicroS();
    const execTime = () => ((timeNowInMicroS() - t1) / 1000);
    const res = f(arg);
    let iterations = 1;
    while (execTime() < 0) {
        iterations = ((iterations + 1) | 0);
        f(arg);
    }
    const t = execTime() / iterations;
    executionStats(add(name, (value_1 = (new Stats(t, t, t, 1)), defaultArg((option_1 = tryFind(name, executionStats()), (option_1 != null) ? addTimeToStats(t, option_1) : undefined), value_1)), executionStats()));
    return res;
}

/**
 * print
 */
export function printStats() {
    iterate((tupledArg) => {
        const st = tupledArg[1];
        const arg_4 = ~~st.Num | 0;
        toConsole(printf("%s time: min=%.3fms max=%.3fms av=%.3fms samples:%d"))(tupledArg[0])(st.Min)(st.Max)(st.Av)(arg_4);
    }, toList_1(executionStats()));
    executionStats(ofSeq([], {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

/**
 * returns absolute time in ms, works under both .Net and Fable
 */
export function getTimeMs() {
    return performance.now();
}

/**
 * The memory the renderer is using, in bytes, as V8 reports it. This is usedJSHeapSize, which
 * counts typed-array backing stores as well as ordinary objects - measured at 4.00 bytes per
 * Uint32Array element - so a delta of it across a phase is the phase's whole allocation, not
 * just its heap objects. Under .NET it is the CLR's figure, useful only for relative deltas.
 */
export function usedHeapBytes() {
    return (performance.memory ? performance.memory.usedJSHeapSize : 0);
}

export function getInterval(startTime) {
    return getTimeMs() - startTime;
}

/**
 * Return time taken by thunk()
 * Run thunk() as many times as is needed
 * for total elapsed time in ms to be  > limitMs.
 * Return average time of all runs.
 * To minimise cache effects run thunk() once before
 * starting to time.
 */
export function getTimeOfInMs(limitMs, thunk) {
    thunk();
    const startT = getTimeMs();
    let i = 0;
    while (getInterval(startT) < limitMs) {
        i = ((i + 1) | 0);
        thunk();
    }
    return getInterval(startT) / i;
}

export class AggregatedData extends Record {
    constructor(PrintInterval, LastPrintTime, Counts, Times, MinVals, MaxVals) {
        super();
        this.PrintInterval = PrintInterval;
        this.LastPrintTime = LastPrintTime;
        this.Counts = Counts;
        this.Times = Times;
        this.MinVals = MinVals;
        this.MaxVals = MaxVals;
    }
}

export function AggregatedData_$reflection() {
    return record_type("TimeHelpers.AggregatedData", [], AggregatedData, () => [["PrintInterval", float64_type], ["LastPrintTime", float64_type], ["Counts", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, int32_type])], ["Times", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, float64_type])], ["MinVals", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, float64_type])], ["MaxVals", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, float64_type])]]);
}

/**
 * controls how time intervals are collected and displayed
 */
export class InstrumentationControl extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ImmediatePrint", "Aggregate", "Off"];
    }
    static Off = new InstrumentationControl(2, []);
}

export function InstrumentationControl_$reflection() {
    return union_type("TimeHelpers.InstrumentationControl", [], InstrumentationControl, () => [[["Threshold", float64_type], ["UpdateThreshold", float64_type]], [["Item", AggregatedData_$reflection()]], []]);
}

/**
 * initialise instrumentation parameter for immediate time printing
 */
export function immediate(threshold, updateThreshold) {
    return new InstrumentationControl(/* ImmediatePrint */ 0, [threshold, updateThreshold]);
}

/**
 * initialse instrumentation parameter for aggregate time printing
 */
export function aggregate(printInterval_1) {
    let LastPrintTime, Times, MinVals, MaxVals;
    return new InstrumentationControl(/* Aggregate */ 1, [(LastPrintTime = getTimeMs(), (Times = empty({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), (MinVals = empty({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), (MaxVals = empty({
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }), new AggregatedData(printInterval_1, LastPrintTime, empty({
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }), Times, MinVals, MaxVals)))))]);
}

export let instrumentation = createAtom(InstrumentationControl.Off);

/**
 * print out the current aggregate of recorded times if this is requried.
 * Return initialised aggregate totals after print
 */
export function printAgg(agg) {
    let arg;
    const now = getTimeMs();
    const intv = now - agg.LastPrintTime;
    if (intv < agg.PrintInterval) {
        return agg;
    }
    else {
        dbg(512, ((arg = (intv / 1000), toText(printf("Interval times in ms after %.1fs\n      Av     Max     Min  Total   Num  Name\n"))(arg))) + join("\n", map_7((tuple_1) => tuple_1[1], sortByDescending((tuple) => tuple[0], map_7((name) => {
            const num = defaultArg(tryFind(name, agg.Counts), 0) | 0;
            if (num === 0) {
                return [0, ""];
            }
            else {
                const tot = defaultArg(tryFind(name, agg.Times), 0);
                return [tot, `${interpolate("%8.2f%P()", [tot / num])}${interpolate("%8.1f%P()", [defaultArg(tryFind(name, agg.MaxVals), 0)])}${interpolate("%8.1f%P()", [defaultArg(tryFind(name, agg.MinVals), 0)])}${interpolate("%8.1f%P()", [tot])}${interpolate("%6d%P()", [num])}  ${name}`];
            }
        }, MapModule_KeysA(agg.Counts)), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }))));
        const Counts = empty({
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        });
        const MaxVals = empty({
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        });
        const MinVals = empty({
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        });
        return new AggregatedData(agg.PrintInterval, now, Counts, empty({
            Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
        }), MinVals, MaxVals);
    }
}

/**
 * process a new time interval updating the aggregated data for future printout
 */
export function updateAgg(name, time, agg) {
    let key_3, map_3;
    let Counts;
    const key = name;
    const map = agg.Counts;
    Counts = add(key, 1 + defaultArg(tryFind(key, map), 0), map);
    let Times;
    const key_1 = name;
    const map_1 = agg.Times;
    Times = add(key_1, time + defaultArg(tryFind(key_1, map_1), 0), map_1);
    let MaxVals;
    const key_2 = name;
    const map_2 = agg.MaxVals;
    MaxVals = add(key_2, max(time, defaultArg(tryFind(key_2, map_2), 0)), map_2);
    return new AggregatedData(agg.PrintInterval, agg.LastPrintTime, Counts, Times, (key_3 = name, (map_3 = agg.MinVals, add(key_3, min(time, defaultArg(tryFind(key_3, map_3), 10000000000)), map_3))), MaxVals);
}

/**
 * According to current settings, process and/or print a named time interval.
 * the interval is between intervalStartTime passed as arg 2, and the time at
 * which this function is called (all times obtained using getTimeMs).
 */
export function instrumentTime(intervalName, intervalStartTime) {
    if (instrumentation().tag === 0) {
        const updateThreshold = instrumentation().fields[1];
        const threshold = instrumentation().fields[0];
        const interval = getInterval(intervalStartTime);
        if (interval > (intervalName.startsWith("update") ? updateThreshold : threshold)) {
            dbg(512, `${intervalName}: ${interpolate("%.1f%P()", [interval])}ms`);
        }
    }
    else if (instrumentation().tag === 1) {
        const agg = instrumentation().fields[0];
        const agg_2 = printAgg(updateAgg(intervalName, getTimeMs() - intervalStartTime, agg));
        instrumentation(new InstrumentationControl(/* Aggregate */ 1, [agg_2]));
    }
}

function printInterval(name, startTime) {
    instrumentTime(name, startTime);
}

/**
 * This function with its first two args should be put in a pipe after the code to be timed.
 * it will return its piped input, with the side effect of recording the time delay in the
 * function. Parameter start must be defined at the start of the code to be timed using getTimeMs.
 */
export function instrumentInterval(name, startTime, output) {
    printInterval(name, startTime);
    return output;
}

/**
 * Record the elapsed time taken in execution of (func arg).
 * Return the result from (func arg).
 */
export function instrumentFunctionCall(name, func, arg) {
    getTimeMs();
    const startTime_1 = func(arg);
    return (output) => instrumentInterval(name, startTime_1, output);
}

